// Gmail store: istanza provider-specifica del mail store generico.
// La logica vive in ./mail (factory createMailStore + gmailAdapter). Qui si
// mantiene l'API pubblica retrocompatibile (useGmailStore + tipi con alias).
import { createMailStore } from './mail/createMailStore';
import { gmailAdapter } from './mail/adapters/gmailAdapter';

export const useGmailStore = createMailStore(gmailAdapter);

// Alias di tipo retrocompatibili: i consumatori continuano a importare i vecchi
// nomi da questo modulo senza modifiche.
export type {
  MailMessage as GmailMessage,
  MailThread as GmailThread,
  MailLabel as GmailLabel,
  MailReplyTemplate as GmailReplyTemplate,
  EmailAttachment,
  DraftSummary,
} from './mail/types';
